import {friendsAPI, usersAPI} from "../API_DAL/api_dal";
import {followUnFollow, setTotalCount} from "./usersReducer";
import sortingUsers from "../Utilits/SortUsersOrFreinds";

const GET_MY_FRIENDS = "GET_MY_FRIENDS";
const SET_ACTIVE_PAGE = "friends/SET_ACTIVE_PAGE";
const SET_FOLLOW_UNFOLLOW = "friends/SET_FOLLOW_UNFOLLOW";
const TOGGLE_PRELOADER = "frineds/TOGGLE_PRELOADER";
const initialState = {
    friends: [],
    activePage: 1,
    isPreloader: false
};

const friendsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MY_FRIENDS:
            return {
                ...state,
                friends: action.friends
            };
        case SET_ACTIVE_PAGE:
            return {
                ...state,
                activePage: action.activePage
            };
        case SET_FOLLOW_UNFOLLOW:
            return {
                ...state,
                friends: sortingUsers(state.friends, action.id, action.follow),
            };
        case TOGGLE_PRELOADER:
            return {
                ...state,
                isPreloader: action.isPreloader
            };
        default:
            return state;
    }
};

export const togglePreloader = (isPreloader) => ({type: TOGGLE_PRELOADER, isPreloader});
const getFriendsSuccess = (friends) => ({type: GET_MY_FRIENDS, friends});
export const setActivePage = (activePage) => ({type: SET_ACTIVE_PAGE, activePage});
const setFollowUnFollowFriends = (follow, id) => ({type: SET_FOLLOW_UNFOLLOW, follow, id});

export const getFriends = (activePage, pageSize, term) => (dispatch) => {
    dispatch(togglePreloader(true));
    friendsAPI.getFriends(activePage, pageSize, term).then(data => {
        if (data.error !== true) {
            dispatch(getFriendsSuccess(data.items));
            dispatch(setTotalCount(data.totalCount));
            dispatch(togglePreloader(false));
        }
    })
};

export const follow = (id) => (dispatch) => {
    followUnFollow(id, usersAPI.follow.bind(usersAPI), setFollowUnFollowFriends, dispatch, true)
};


export const unFollow = (id) => (dispatch) => {
    followUnFollow(id, usersAPI.unFollow.bind(usersAPI), setFollowUnFollowFriends, dispatch, false)
};

export default friendsReducer;